export enum ControllerType {
  ROW_CONTROLLER = 1,
  COLUMN_CONTROLLER = 2,
  CORNER_CONTROLLER = 3,
}

export const borderWidth = 1; // We could change it to a paramter instead of a constant if we want to support more border width values.
